/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgEnter = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="M9.742 20 2 12l7.742-8L11 5.3 5.484 11H20V7h2v6H5.484L11 18.7z"
      fill="currentcolor"
      fillRule="evenodd"
    />
  </Icon>
);
export { SvgEnter as Enter };
